import * as React from "react"
import * as ReactDOM from "react-dom"
import { Moment } from 'moment';
import * as moment from 'moment';

declare var I18n: any

type Props = {
  max_people_select: number
  max_people: number
  onChange: (_:number) => void
}

type State = {
}

export default class MobilePeriodSelection extends React.Component<Props, State> {
  subscriptionToken: string

  constructor(props : Props, context) {
    super(props, context)
  }

  render() {
    let options : JSX.Element[] = []
    for(let i = 1; i <= this.props.max_people_select; i++) {
       options.push(<option key={`people_${i}`} value={i}>{i}</option>)
    }
    return (
      <div className="box--padding box--flex">
        <select
          className="select--person-number"
          value={this.props.max_people || ''}
          onChange={(e) => this.props.onChange(parseInt(e.target.value))}>
          {options}
        </select>
        <span className="select--persons">{I18n.t("rental_adverts.booking_form.people_abbr")}</span>
      </div>
    )
  }
}
